const GraduationCapIcon = ({ color = '#9CA3AF', size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 9.5L12 4l10 5.5-10 5.5L2 9.5z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M6 11.5v4.2c0 .5.2.9.6 1.2C8 18 10 18.8 12 18.8s4-.8 5.4-1.9c.4-.3.6-.7.6-1.2v-4.2" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 9.8v5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
)

export default GraduationCapIcon
